import React from "react"
import Layout from "../components/layout/Layout"

function Exclusive() {
  return <Layout title={"TMP - Exclusive"}>Exclusive</Layout>
}

export default Exclusive
